export function pickTranslation(translations, locale) {
  if (!translations) {
    return "";
  }

  if (translations[locale]) {
    return translations[locale];
  }

  const base = locale.split("-")[0];
  const match = Object.keys(translations).find(
    (key) => key === base || key.startsWith(`${base}-`)
  );

  return match ? translations[match] : Object.values(translations)[0] ?? "";
}
